import { UseDisclosureReturn } from "@/utils/useDisclosure";
import { createContext, ReactNode, useEffect, useState } from "react";
import { UseFormReturn } from "react-hook-form";

interface ContextType {
  templateModalControls?: UseDisclosureReturn;
  deleteTriggersModalControls?: UseDisclosureReturn;
  runModalControls?: UseDisclosureReturn;
  form?: UseFormReturn;
  isReadOnly?: boolean;
  workflowVersionId?: string;
}

export const EditorContext = createContext<ContextType>({
  deleteTriggersModalControls: undefined,
  templateModalControls: undefined,
  runModalControls: undefined,
  form: undefined,
  workflowVersionId: undefined,
  isReadOnly: false,
});

export const EditorContextProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: ContextType;
}) => {
  const [context, setContext] = useState(value);

  return (
    <EditorContext.Provider value={context}>{children}</EditorContext.Provider>
  );
};
